import { render } from "./BoxLabel.vue?vue&type=template&id=4405a3b2&lang=pug"
import script from "./BoxLabel.vue?vue&type=script&lang=js"
export * from "./BoxLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__